import React from 'react';
import AdminPanel from '../../components/AdminPanel/AdminPanel';

function AdminPanelPage() {
  return <AdminPanel />;
}

export default AdminPanelPage;
